import CountUP from '../includes/CountUp';

import { useDashboard } from '../context/DashboardContext';

export default function ScoreCards({loadingState, response}) {
    const { data: { accounting } } = useDashboard();
    return (
        <div className="dashboard-scorecards flex justify-between">
            <div className="scorecard block max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow-sm">
                <svg class="shadow-bg" xmlns="http://www.w3.org/2000/svg" width="200" height="150" viewBox="0 0 151 95" fill="none">
                    <ellipse cx="30.8219" cy="-18.8406" rx="93.2712" ry="77.0744" transform="rotate(29.677 30.8219 -18.8406)" fill="#959699" fill-opacity="0.08"></ellipse>
                </svg>
                <h3 class="mb-2">Net Total B2B</h3>
                    {loadingState ? <Skeleton /> : (
                    <>
                        <h1 class="scorecard-number mb-4 text-4xl font-extrabold leading-none tracking-tight text-gray-900 md:text-5xl lg:text-6xl">
                            <CountUP end={response?.net?.value} accounting={accounting} />
                        </h1>
                        <span className='flex items-center' style={{ gap: '5px' }}>
                            <span className={`flex items-ceter ${'top' == response?.net?.comparison?.type ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'} text-xs font-medium me-2 px-2.5 py-0.5 rounded-sm`} style={{ gap: '5px' }}>
                            <span>+ <CountUP end={response?.net?.comparison?.value} />%</span>
                                <svg style={{ transform: ('top' == response?.net?.comparison?.type) ? 'none' : 'rotate(180deg)' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trending-up">
                                    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18">
                                    </polyline><polyline points="17 6 23 6 23 12"></polyline>
                                </svg>
                            </span>
                            <span>{response?.net?.comparison?.label}</span>
                        </span>
                    </>
                )}
            </div>
            <div className="scorecard block max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow-sm">
                <svg class="shadow-bg" xmlns="http://www.w3.org/2000/svg" width="200" height="150" viewBox="0 0 151 95" fill="none">
                    <ellipse cx="30.8219" cy="-18.8406" rx="93.2712" ry="77.0744" transform="rotate(29.677 30.8219 -18.8406)" fill="#959699" fill-opacity="0.08"></ellipse>
                </svg>
                <h3 class="mb-2">Gross Total B2B</h3>
                    {loadingState ? <Skeleton /> : (
                    <>
                        <h1 class="scorecard-number mb-4 text-4xl font-extrabold leading-none tracking-tight text-gray-900 md:text-5xl lg:text-6xl">
                            <CountUP end={response?.gross?.value} accounting={accounting} />
                        </h1>
                        <span className='flex items-center' style={{ gap: '5px' }}>
                            <span className={`flex items-ceter ${'top' == response?.gross?.comparison?.type ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'} text-xs font-medium me-2 px-2.5 py-0.5 rounded-sm`} style={{ gap: '5px' }}>
                            <span>+ <CountUP end={response?.gross?.comparison?.value} />%</span>
                                <svg style={{ transform: ('top' == response?.gross?.comparison?.type) ? 'none' : 'rotate(180deg)' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trending-up">
                                    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18">
                                    </polyline><polyline points="17 6 23 6 23 12"></polyline>
                                </svg>
                            </span>
                            <span>{response?.gross?.comparison?.label}</span>
                        </span>
                    </>
                )}
            </div>
            <div className="scorecard block max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow-sm">
                <svg class="shadow-bg" xmlns="http://www.w3.org/2000/svg" width="200" height="150" viewBox="0 0 151 95" fill="none">
                    <ellipse cx="30.8219" cy="-18.8406" rx="93.2712" ry="77.0744" transform="rotate(29.677 30.8219 -18.8406)" fill="#959699" fill-opacity="0.08"></ellipse>
                </svg>
                <h3 class="mb-2">Wholesale Orders Count</h3>
                    {loadingState ? <Skeleton /> : (
                    <>
                        <h1 class="scorecard-number mb-4 text-4xl font-extrabold leading-none tracking-tight text-gray-900 md:text-5xl lg:text-6xl">
                            <CountUP end={response?.count?.value} />
                        </h1>
                        <span className='flex items-center' style={{ gap: '5px' }}>
                            <span className={`flex items-ceter ${'top' == response?.count?.comparison?.type ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'} text-xs font-medium me-2 px-2.5 py-0.5 rounded-sm`} style={{ gap: '5px' }}>
                            <span>+ <CountUP end={response?.count?.comparison?.value} />%</span>
                                <svg style={{ transform: ('top' == response?.count?.comparison?.type) ? 'none' : 'rotate(180deg)' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trending-up">
                                    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18">
                                    </polyline><polyline points="17 6 23 6 23 12"></polyline>
                                </svg>
                            </span>
                            <span>{response?.count?.comparison?.label}</span>
                        </span>
                    </>
                )}
            </div>
            <div className="scorecard block max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow-sm">
                <svg class="shadow-bg" xmlns="http://www.w3.org/2000/svg" width="200" height="150" viewBox="0 0 151 95" fill="none">
                    <ellipse cx="30.8219" cy="-18.8406" rx="93.2712" ry="77.0744" transform="rotate(29.677 30.8219 -18.8406)" fill="#959699" fill-opacity="0.08"></ellipse>
                </svg>
                <h3 class="mb-2">Average Order Value</h3>
                    {loadingState ? <Skeleton /> : (
                    <>
                        <h1 class="scorecard-number mb-4 text-4xl font-extrabold leading-none tracking-tight text-gray-900 md:text-5xl lg:text-6xl">
                            <CountUP end={response?.aov?.value} accounting={accounting} />
                        </h1>
                        <span className='flex items-center' style={{ gap: '5px' }}>
                            <span className={`flex items-ceter ${'top' == response?.aov?.comparison?.type ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'} text-xs font-medium me-2 px-2.5 py-0.5 rounded-sm`} style={{ gap: '5px' }}>
                            <span>+ <CountUP end={response?.aov?.comparison?.value} />%</span>
                                <svg style={{ transform: ('top' == response?.aov?.comparison?.type) ? 'none' : 'rotate(180deg)' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trending-up">
                                    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18">
                                    </polyline><polyline points="17 6 23 6 23 12"></polyline>
                                </svg>
                            </span>
                            <span>{response?.aov?.comparison?.label}</span>
                        </span>
                    </>
                )}
            </div>

        </div>
    );
};

function Skeleton() {
    return (
        <div role="status" className="space-y-8 animate-pulse md:space-y-0 md:space-x-8 rtl:space-x-reverse md:flex md:items-center">
            <div className="w-full">
            <div class="h-2.5 bg-gray-200 rounded-full mb-2.5" style={{ width: '120px' }}></div>
            <div class="h-2.5 bg-gray-200 rounded-full w-48" style={{ width: '120px', marginBottom: '30px' }}></div>
            <div class="h-2 bg-gray-200 rounded-full max-w-[460px] mb-2.5"></div>
            <div class="h-2 bg-gray-200 rounded-full max-w-[360px]"></div>
            </div>
            <span className="sr-only">Loading...</span>
        </div>
    );
}